import { createFileRoute } from '@tanstack/react-router';
import {
  dynamicRulesSimulateScreen,
  loadDynamicRulesMessages,
  loadDynamicRulesScreens,
} from '@/modules/dynamic-rules/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/cadastro/regras-dinamicas/simular/')({
  staticData: { screen: dynamicRulesSimulateScreen },
  loader: () => loadDynamicRulesMessages(),
  component: lazyScreen(loadDynamicRulesScreens, 'DynamicRuleSimulateScreen'),
});
